"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRRuleToTz = void 0;
const timezone_date_1 = require("./timezone-date");
const formatRRuleToTz = ({ rrule, allday, timezone, }) => {
    return {
        ...rrule,
        dtstart: allday
            ? (0, timezone_date_1.formatToDateInTz)({
                date: rrule.dtstart,
                timezone,
            })
            : (0, timezone_date_1.formatToDateTimeInTz)({
                date: rrule.dtstart,
                timezone,
            }),
        until: rrule.until
            ? allday
                ? (0, timezone_date_1.formatToDateInTz)({
                    date: rrule.until,
                    timezone,
                })
                : (0, timezone_date_1.formatToDateTimeInTz)({ date: rrule.until, timezone })
            : null,
        tzid: timezone,
    };
};
exports.formatRRuleToTz = formatRRuleToTz;
